import { useRoutes } from 'react-router-dom'
import React, { Suspense } from 'react'
import { useRecoilValue } from 'recoil'

import { menuListState } from 'store/atom/app-state-atom'
import { useMemo } from 'react'
import { retryLazy } from 'utils/common-util'

//Root
const Root = retryLazy(() => import('pages/Root'))
//로그인
const Login = retryLazy(() => import('pages/Login'))
//설치페이지
const Install = retryLazy(() => import('pages/Install'))
//404페이지
const NotFound = retryLazy(() => import('pages/NotFound'))
//Layout
const MainLayout = retryLazy(() => import('pages/layout/MainLayout'))
//메인
const Main = retryLazy(() => import('pages/Main'))
//검색
const Search = retryLazy(() => import('pages/search/Search'))

const loadComponent = (path) => retryLazy(() => import(`../${path}.jsx`))

// 다차원 배열 1차원으로 (라우터 한정)
const convertRouterConcat = (arr, itemName = 'subMenus') =>
  arr.reduce((acc, val) => {
    // 하위 라우트 추가
    if (val[itemName]) acc.push(...val[itemName])

    // 재귀 함수
    for (let route of val[itemName]) {
      if (route[itemName]) acc.push(...convertRouterConcat([route], itemName))
    }
    return acc
  }, [])

// 동적 라우팅
export default function Router() {
  const data = useRecoilValue(menuListState)
  const router = useMemo(() => getRoute(data), [data])
  return useRoutes(router)
}

const getRoute = (data) => {
  return [
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/',
      element: <Root />,
    },
    {
      path: '/install',
      element: <Install />,
    },
    {
      path: '/*',
      element: <NotFound />,
    },
    {
      element: <MainLayout />,
      children: [
        {
          path: '/main',
          element: <Main />,
        },
        {
          path: '/search',
          element: <Search />,
        },
        // 추가되는 라우터 정의
        ...convertRouterConcat(data.filter(({ subMenus }) => subMenus)).map(({ component, componentName }) => {
          const Ele = loadComponent(component)
          //console.log(component, componentName)

          return {
            path: componentName,
            element: (
              <Suspense fallback={<></>}>
                <Ele />
              </Suspense>
            ),
          }
        }),
      ],
    },
  ]
}
